<header
  class="bcledger-header d-flex align-items-center justify-content-between has-border py-3 mb-4">
  <h1>Freight Charges Invoice Preview</h1>
  <div class="bcledger-panel d-flex justify-content-between ms-2 me-auto">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <jni-spinner></jni-spinner>
    </div>
  </div>
  <div class="user-panel col-auto d-flex justify-content-between">
    <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
      <i class="icon-Export-excel me-2"></i>
      <a class="link" (click)="exportExcelFile()">Export excel</a>
    </div>
  </div>
</header>

<div class="p-wrapper-custom">
  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="freightChargesInvoicePreviewDetailValue"
    styleClass="p-datatable-customers"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [autoLayout]="true"
    [resizableColumns]="true"
    [paginator]="freightChargesInvoicePreviewDetailValue.length >= 20">
    <ng-template pTemplate="caption">
      <div class="d-flex align-items-center">
        <ng-container> </ng-container>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <!-- <th>Charges Code</th> -->
        <th style="width: 6rem">Category</th>
        <th>Keep</th>
        <th>Amount</th>
        <th>Currency</th>
        <th>Reference</th>
        <th>Project Id</th>
        <th>Number</th>
        <th>Freight Bill #</th>
        <th>Tracking</th>
        <th>Created By</th>
        <th>Created Date and Time</th>
        <th>Modified By</th>
        <th>Modified Date and Time</th>
      </tr>
      <tr>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="ChargeCategory"
              id="ChargeCategory"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'ChargeCategory',
                  'startsWith'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-freightChargesList
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="freightChargesList"
        [pSelectableRowIndex]="rowIndex">
        <td>{{ freightChargesList?.ChargeCategory }}</td>
        <td>{{ freightChargesList?.Keep }}</td>
        <td>{{ freightChargesList?.ChargeValue | number: "1.2-2" }}</td>
        <td>{{ freightChargesList?.currencyCode }}</td>
        <td>{{ freightChargesList?.RsmReferenceCategory }}</td>
        <td>{{ freightChargesList?.ReferenceProjId }}</td>
        <td>{{ freightChargesList?.rsmReferenceId }}</td>
        <td>{{ freightChargesList?.FreightBillingNum }}</td>
        <td>{{ freightChargesList?.TrackingNumber }}</td>
        <td>{{ freightChargesList?.CreatedBy1 }}</td>
        <td>{{ freightChargesList?.CreatedDateTime1 }}</td>
        <td>{{ freightChargesList?.modifiedBy1 }}</td>
        <td>{{ freightChargesList?.ModifiedDateTime1 }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="30">No Data Found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
